import "./Button.scss";
import { useState } from "react";

interface Props {
  id?: string;
  children: string;
  outlined?: boolean;
  red?: boolean;
  grey?: boolean;
  small?: boolean;
  fullwidth?: boolean;
  disabled?: boolean;
  onClick?: Function;
  htmlFor?: string;
  style?: any;
  loading?: boolean;
}

export const Button = ({
  id,
  children,
  outlined,
  red,
  grey,
  small,
  fullwidth,
  disabled,
  onClick,
  htmlFor,
  style,
  loading,
}: Props) => {
  const [mouseDown, setMouseDown] = useState(false);
  const isDisabledOrLoading = disabled || loading;

  const getColor = () => {
    const colors = {
      orange: "#FE7C40",
      red: "#F40F0F",
      lightgrey: "#BFBFBF",
      grey: "#989898",
    };

    if (mouseDown) {
      return colors.lightgrey;
    }

    if (red) return colors.red;

    if (grey) return colors.grey;

    return colors.orange;
  };

  let styleButton = {
    "--color": getColor(),
    "--cursor": isDisabledOrLoading ? "default" : "pointer",
    "--opacity": isDisabledOrLoading ? "30%" : "100%",
    "--fontSize": small ? "12px" : "14px",
    "--height": small ? "25px" : "35px",
    "--padding": small ? "0px 10px" : "0px 20px",
    "--width": fullwidth ? "100%" : "",
  };

  if (style) {
    styleButton = {
      ...styleButton,
      ...style,
    };
  }

  const handleOnClick = () => {
    if (onClick && !isDisabledOrLoading) {
      onClick();
    }
  };

  const handleOnMouseDown = () => {
    if (!isDisabledOrLoading) {
      setMouseDown(true);
    }
  };

  const handleOnMouseUp = () => {
    if (!isDisabledOrLoading) {
      setMouseDown(false);
    }
  };

  return (
    <button
      id={id}
      type="button"
      className={`${outlined ? "button-outlined" : "button"}`}
      //@ts-ignore
      style={styleButton}
      onClick={handleOnClick}
      onMouseDown={handleOnMouseDown}
      onMouseUp={handleOnMouseUp}
      htmlFor={htmlFor}
    >
      {loading && "CARGANDO"}
      {!loading && children && children.toUpperCase()}
    </button>
  );
};
